export default __webpack_public_path__ + "static/media/q.4004f2ea.mp4";